import $http from "../../axios";
import {
  Notification,
  MessageBox
} from 'element-ui';

//consulta kardex
export async function getKardex({commit,state}) {
    state.loading.kardex = true
    var data = {
        params: state.params,
        product: state.product
    }
    await $http.get('/api/validacion-kardex', data)
        .then((response) => {
            commit('setKardex', response.data.data)
        })
        .catch((error) => {
            Notification.error({
                title: 'Error!',
                message: error.message,
                type: 'error',
                duration: 1500,
                customClass: 'notification-box',
            });
        })
    state.loading.kardex = false
}



// WEBPACK FOOTER //
// ./src/modules/validate-kardex/actions.js